const downloadFileFromJsonBlob = (fileResponse, fileName, preview = false) => {
  const base64 = fileResponse.content;
  const extension = fileResponse.type || ".pdf";

  let mimeType = "application/octet-stream";

  if (extension === ".pdf") mimeType = "application/pdf";
  if (extension === ".jpg" || extension === ".jpeg") mimeType = "image/jpeg";
  if (extension === ".png") mimeType = "image/png";
  if (extension === ".doc") mimeType = "application/msword";
  if (extension === ".docx")
    mimeType =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

  // Convert base64 to byte array
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: mimeType });

  const url = window.URL.createObjectURL(blob);

  if (preview == false) {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || `document${extension}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } else {
    return url;
  }
};

const getMimeType = (base64) => {
  if (base64.startsWith("/9j/")) return "image/jpeg"; // JPEG
  if (base64.startsWith("iVBORw0KGgo")) return "image/png"; // PNG
  if (base64.startsWith("R0lGOD")) return "image/gif"; // GIF
  if (base64.startsWith("Qk")) return "image/bmp"; // BMP
  if (base64.startsWith("SUkq")) return "image/tiff"; // TIFF (Little Endian)
  if (base64.startsWith("TU0AKg")) return "image/tiff"; // TIFF (Big Endian)
  if (base64.startsWith("UklGR")) return "image/webp"; // WebP (RIFF)
  if (base64.startsWith("AAABAA")) return "image/x-icon"; // ICO
  if (base64.startsWith("PHN2Zy")) return "image/svg+xml"; // SVG (rare if base64-encoded)

  return "application/octet-stream";
};

export { downloadFileFromJsonBlob, getMimeType };
